
import { NoticeProps, UserReceivedMessage, UserSentMessage} from "@/scripts/datatypes"
import { Component,Mixins,Prop} from "vue-property-decorator";
import { ValidationObserver  } from 'vee-validate'
import {$autoSaveInterval} from '@/scripts/common'

import Common from '@/mixins/common'
import {getDoc} from 'firebase/firestore';
import { EventData, SchedulingSheet, UserPublicProfile } from "@/common-datatypes"
import ModalSelectUser from '@/components/ModalSelectUser.vue'
import ModalSelectEvent from '@/components/ModalSelectEvent.vue'
import TemplateMembers from '@/components/TemplateMembers.vue'
@Component({
  components: {
    ModalSelectUser,
    ModalSelectEvent,
    TemplateMembers,
  }
})

//TODO 送信先を増加する

export default class ModalStaffSchedulingMessenger extends Mixins(Common) {
  @Prop({type: String, default: ''}) private theMessageId?: string
  @Prop({type: String, default: ''}) private reviewMessageId?: string
  @Prop({type: String, default: ''}) private replyMessageId?: string
  @Prop({type: String, default: ''}) private replyAllMessageId?: string
  @Prop({type: Object, default: () => {return {}}}) private theSchedulingData?: SchedulingSheet
  isActive = true
  isModalSelectUserShow = false
  isModalSelectEventShow = false
  memberUserIds: string[] = []
  sentMessages: UserSentMessage[] = []
  receivedMessages: UserReceivedMessage[] = []
  theMessage = {
    receiverUserIds: [] as string[],
    receiverMeta: {} as UserSentMessage['receiverMeta'],
    referenceObjectIds: [] as string[],
		referenceObjectMeta: {},
    body: ''
  }  as UserSentMessage
  prevBody = ''

  messageId = ''
  isLoading = false
  notice = {} as NoticeProps
  
  referenceObjectName = ''

  $refs!: {
    validationObserver: InstanceType<typeof ValidationObserver>;
  }

  observer = {} as InstanceType<typeof ValidationObserver>

  onSelectEvent(event: false | EventData){
    if(event === false){
      this.isModalSelectEventShow = false
      return
    }
    this.toggleEvent(event)
  }

  get isDisabled(){
    return ! this.theMessage.body
  }

  autoSaveTimer?: number

get userId(): string {
  return this.$store.getters.userId
}

  toggleEvent(event: EventData | string){
    const theEventDocId =  (typeof event === 'string') ? event : event.extendedProps.docId  || ''
    console.log('toggle')
    console.log(theEventDocId)
    
    if(this.theMessage.referenceObjectIds?.includes(theEventDocId)){
      if(this.theMessage.referenceObjectMeta && this.theMessage.referenceObjectMeta[theEventDocId]){
        delete this.theMessage.referenceObjectMeta[theEventDocId]
      }
      this.theMessage.referenceObjectIds = this.theMessage.referenceObjectIds.filter((objectId) => {
        return objectId !== theEventDocId
      })
    }else{
      this.theMessage.referenceObjectIds = this.theMessage.referenceObjectIds?.concat([theEventDocId])
      if(typeof event === 'object' && this.theMessage.referenceObjectMeta){
        const eventMeta = {
          ref: this.$getEventDocRef(theEventDocId),
          name: this.$getReferenceObjectName(event,'event'),
          type: 'event',
          date: event.start,
          creationTime: event.creationTime || new Date(),
          updateTime: event.updateTime || new Date()
        }
        this.theMessage.referenceObjectMeta[theEventDocId] = eventMeta
      }
    }
  }

  toggleScheduling(scheduling: SchedulingSheet | string){
    const theSchedulingId =  (typeof scheduling === 'string') ? scheduling : scheduling.docId  || ''
    
    if(this.theMessage.referenceObjectIds?.includes(theSchedulingId)){
      if(this.theMessage.referenceObjectMeta && this.theMessage.referenceObjectMeta[theSchedulingId]){
        delete this.theMessage.referenceObjectMeta[theSchedulingId]
      }
      this.theMessage.referenceObjectIds = this.theMessage.referenceObjectIds.filter((objectId) => {
        return objectId !== theSchedulingId
      })
    }else{
      this.theMessage.referenceObjectIds = this.theMessage.referenceObjectIds?.concat([theSchedulingId])
      if(typeof scheduling === 'object' && this.theMessage.referenceObjectMeta){
        const schedulingMeta = {
          ref: this.$getSchedulingSheetDocRef(theSchedulingId),
          name: this.$getReferenceObjectName(scheduling,'scheduling'),
          type: 'scheduling',
          date: scheduling.start || new Date(),
          creationTime: scheduling.creationTime || new Date(),
          updateTime: scheduling.updateTime || new Date()
        }
        this.theMessage.referenceObjectMeta[theSchedulingId] = schedulingMeta

      }
    }
  }

  mounted(){
    console.log('mounted')
    this.observer = this.$refs.validationObserver

    //this.$watch('observer.flags',(flags: ValidationFlags) => {
    //  this.isDisabled = ! flags.changed
    //})
  }

  async created(){
    console.trace('created')

    this.autoSaveTimer = window.setInterval(() => {
      this.autoSave()
    }, $autoSaveInterval)

    this.$store.commit("setLoading",true);
    this.isLoading = true
    
    try{
      if(this.theMessageId){
        this.messageId = this.theMessageId
      }

      if(this.theSchedulingData){
        this.referenceObjectName = this.$getReferenceObjectName(this.theSchedulingData, 'scheduling')

        this.toggleScheduling(this.theSchedulingData)

        if(this.messageId){
          const messageData = (await getDoc(this.$getUserSentMessageDocRef(this.messageId))).data() as UserSentMessage

          if(this.theSchedulingData.docId && messageData.referenceObjectIds?.includes(this.theSchedulingData.docId)){
            this.theMessage = messageData
            this.prevBody = messageData.body
          }
        }
      }

      if(this.replyAllMessageId){
        //受信メールへの返信
        const replyMessageDocRef = this.$getUserSentMessageDocRef(this.replyAllMessageId)
        const replyMessageDoc = await getDoc(replyMessageDocRef)
        const replyMessageData = replyMessageDoc.data() as UserSentMessage

        if(replyMessageData){
          this.theMessage.receiverUserIds = this.theMessage.receiverUserIds?.concat(replyMessageData.receiverUserIds || [])
          this.theMessage.receiverMeta = replyMessageData.receiverMeta || {}
          
          this.theMessage.receiverUserIds?.push(replyMessageData.senderUserId)
          this.theMessage.receiverMeta = {
            ...this.theMessage.receiverMeta,
            [replyMessageData.senderUserId]: replyMessageData.senderMeta
          }
          
          this.theMessage.body = replyMessageData.body.replace(/^(\S)/gm,'> $1')
          this.theMessage.referenceObjectIds = Array.from(new Set(this.theMessage.referenceObjectIds?.concat(replyMessageData.referenceObjectIds || [])))
          this.theMessage.referenceObjectMeta = {
            ...this.theMessage.referenceObjectMeta,
            ...replyMessageData.referenceObjectMeta
          }
        }
      }else if(this.replyMessageId){
        //受信メールへの返信
        const receivedMessageDocRef = this.$getUserReceivedMessageDocRef(this.replyMessageId)
        const sentMessageDocRef = this.$getUserSentMessageDocRef(this.replyMessageId)

        const receivedMessageDoc = await getDoc(receivedMessageDocRef)

        const replyMessageDoc = receivedMessageDoc.exists() ? receivedMessageDoc : await getDoc(sentMessageDocRef)
        const replyMessageData = replyMessageDoc.data()

        if(replyMessageData){
          if(replyMessageData.senderUserId == this.userId){
            this.theMessage.receiverUserIds = replyMessageData.receiverUserIds
            this.theMessage.receiverMeta = replyMessageData.receiverMeta
          }else{
            this.theMessage.receiverUserIds = [replyMessageData.senderUserId]
            this.theMessage.receiverMeta = {
              [replyMessageData.senderUserId]: replyMessageData.senderMeta
            }
          }
          this.theMessage.body = replyMessageData.body.replace(/^(\S)/gm,'> $1')
          this.theMessage.referenceObjectIds = Array.from(new Set(this.theMessage.referenceObjectIds?.concat(replyMessageData.referenceObjectIds || [])))
          this.theMessage.referenceObjectMeta = {
            ...this.theMessage.referenceObjectMeta,
            ...replyMessageData.referenceObjectMeta
          }
        }
      }else if(this.reviewMessageId){
        const reviewMessageDocRef = this.$getUserSentMessageDocRef(this.reviewMessageId)
        const reviewMessageData = (await getDoc(reviewMessageDocRef)).data()
        if(reviewMessageData){
          if(reviewMessageData.senderUserId != this.userId){
            this.theMessage.receiverUserIds = [reviewMessageData.senderUserId]
            this.theMessage.receiverMeta = {
              [reviewMessageData.senderUserId]: reviewMessageData.senderMeta
            }
          }
          this.theMessage.body = reviewMessageData.body.replace(/^(\S)/gm,'> $1')
          this.theMessage.referenceObjectIds = Array.from(new Set(this.theMessage.referenceObjectIds?.concat(reviewMessageData.referenceObjectIds || [])))
          this.theMessage.referenceObjectMeta = {
            ...this.theMessage.referenceObjectMeta,
            ...reviewMessageData.referenceObjectMeta
          }
        }
      }

      this.theMessage.receiverUserIds =  Array.from(new Set(this.theMessage.receiverUserIds))
      
    }catch(error){
      console.log(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  onConfirm(yes: boolean) {
    this.$emit("onConfirm", yes);
  }

  async saveMessage(status: 'sending' | 'draft'){
    const userPublicProfile = this.$store.state.userPublicProfile as UserPublicProfile
    
    const data: UserSentMessage = {
      ...this.theMessage,
      senderUserId: this.userId,
      senderMeta: {
        lastName: userPublicProfile.lastName || '',
        firstName: userPublicProfile.firstName || '',
        lastNameYomigana: userPublicProfile.lastNameYomigana || '',
        firstNameYomigana: userPublicProfile.firstNameYomigana || '',
        ref: this.$getUserPublicProfileDocRef()
      },
      status: status,
    }

    if(this.theMessage.receiverUserIds?.length === 0){
      data.status = 'draft'
    }

    if(this.messageId === ''){
      const messageDoc =  await this.$createDoc(this.$getUserSentMessageColRef(),data)

      if(messageDoc){
        this.messageId = messageDoc.id
      }
    }else{
      await this.$updateDoc(this.$getUserSentMessageDocRef(this.messageId),data)
    }
    this.prevBody = data.body
  }

  async autoSave(){
    if(this.theMessage.body == '' || this.theMessage.body == this.prevBody){
      return
    }

    try{
      if(await this.observer.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true
        await this.saveMessage('draft')
      }
    }catch(error){
      console.table(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  async sendMessage(status: 'sending' | 'draft'){
		try{

			this.notice = {
				isShow: false,
			}
		
      if(await this.observer.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true

        await this.saveMessage(status)

        if(status === 'sending'){
          this.notice = {
            message: this.$t('messenger.success') as string,
            isShow: true,
            duration: 0,
            type: {'is-success': true}
          }
        }else if(status === 'draft'){
          this.notice = {
            message: this.$t('messenger.save') as string,
            isShow: true,
            duration: 0,
            type: {'is-info': true}
          }
        }
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('messenger.failure') as string
      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
			
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
  
  destroyed() {
    console.trace('destroyed')
    window.clearInterval(this.autoSaveTimer)
  }

}
